module.exports = Object.assign(
  require('./Approval.json'),
  {
    visibility: false,
    locked: true,
    deletable: false,
    tabs: [{
        id: 'approval',
        title: 'ProjectDetails.approval',
        icon: 'clipboard-check',
        iconPrefix: 'fas',
        type: 'approval',
        classes: ['pdf'],
        form: [{
                "id": "previewUrl",
                "label": "URL",
                "type": "url",
            }
        ]
    }]
});
